import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Menu as MenuComponent, MenuItem } from '@progress/kendo-react-layout';
import menuConfig from './menuConfig';

const root = menuConfig.root;

const renderItem = (props) => (
    <div className="menu-item-container">
        <div><span className={"k-icon k-icon-32 " + props.item.data.icon}></span></div>
        <div className="menu-item-text">{props.item.text}</div>
    </div>
);


const Menu = () => {

    const history = useHistory();
    const {pathname} = useLocation();

    function onSelect(event) {
        history.push(event.item.data.route);
    }

    const menuItems = menuConfig.items.map(item => {
        let itemClass = '';
        if((item.path === pathname) || 
            (item.path !== root && pathname.startsWith(item.path))) {
                itemClass = 'menu-selected-item';
        }
        //Added icon to the data object to prevent Kendo to make a default render of the icon
        return <MenuItem key={item.text} text={item.text} 
                data={{ route: item.path, icon: item.icon }} cssClass={itemClass}  />;
    });

    return (
        <MenuComponent vertical={true} onSelect={onSelect} itemRender={renderItem}>
            {menuItems}
        </MenuComponent>
    );

};

export default Menu;